module.exports = __webpack_public_path__ + "img/im_logo.e320eb06.png";